/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";

class Vitals extends BaseCom {

    onChange = (v) => {
        this.props.onChange?.(v);
    }

    render() {
        if(!this.props.item) return null;
        return <div className="Vitals">
            <Card title="Vital Signs">
                <FormInput model={this.props.item} name="bloodPressure" label="Pressure" type="text" placeholder="000/00" onChange={this.onChange} disabled={this.props.disabled} />
                <FormInput model={this.props.item} name="heartRate" label="Heart Rate" type="number" disabled={this.props.disabled} onChange={this.onChange} />
                <FormInput model={this.props.item} name="temperature" label="Temperature" type="number" placeholder="00.0" step="0.1" onChange={this.onChange} disabled={this.props.disabled} />
                <FormInput model={this.props.item} name="pulseOx" label="Pulse OX" type="number" placeholder="00" step="1" onChange={this.onChange} disabled={this.props.disabled} />
            </Card>
        </div>;
    }
}

export default Vitals;